var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58465 0 0 3.58465 0 8C0 12.4153 3.58465 16 8 16C12.4153 16 16 12.4153 16 8C16 3.58465 12.4153 0 8 0ZM8.80803 8L11.6897 5.11824C11.9126 4.89541 11.9126 4.53316 11.6897 4.31033C11.4668 4.08738 11.1046 4.08738 10.8818 4.31033L8 7.19197L5.11824 4.31033C4.89541 4.08738 4.53316 4.08738 4.31033 4.31033C4.08738 4.53317 4.08738 4.89541 4.31033 5.11824L7.19197 8L4.31033 10.8818C4.08738 11.1046 4.08738 11.4668 4.31033 11.6897C4.53317 11.9126 4.89541 11.9126 5.11824 11.6897L8 8.80803L10.8818 11.6897C11.1046 11.9126 11.4668 11.9126 11.6897 11.6897C11.9126 11.4668 11.9126 11.1046 11.6897 10.8818L8.80803 8Z",
    fill: "#E32020"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.d459b3a65ae073ee77cbd561e8b0cfa8.svg";
export { ForwardRef as ReactComponent };